export const NO_VALUE = '–'; // en-dash

export const HYPHEN = '-';

export const INFINITY = '∞';
